import { BaseObject, IBaseObject } from './BaseObject';

export interface IEquipement extends IBaseObject {
  idSousSysteme: number;
  nomSousSysteme: string;
  nom: string;
  localisation: string;
  nomAction1: string;
  urlAction1: string;
  nomAction2: string;
  urlAction2: string;
  nomAction3: string;
  urlAction3: string;
  idEtat: number;
  idCartoEquipement: string;
  descriptionEtat: string;
  message: string | null;
  idExterne: string;
  vecLayerId: string;
  vecSubLayerId: number;
}

export class Equipement extends BaseObject implements IEquipement {
  descriptionEtat = '';
  idEtat = -1;
  idSousSysteme = -1;
  localisation = '';
  message = null;
  nom = '';
  nomSousSysteme = '';
  nomAction1 = '';
  nomAction2 = '';
  nomAction3 = '';
  urlAction1 = '';
  urlAction2 = '';
  urlAction3 = '';
  idExterne = '';
  idCartoEquipement = '';
  vecLayerId!: string;
  vecSubLayerId!: number;

  constructor(props?: IEquipement) {
    super(props);

    if (props) {
      Object.assign(this, props);
    }
  }

  static SearchFieldForMap = 'ID';
}
